import type { LocalizedDict } from '../index'

export type SampleShareStrings = {
  share: string
  preparing: string
  message: (label: string) => string
  mailBody: (label: string, url: string) => string
  title: string
  subtitle: string
  close: string
  email: string
  copied: string
  copyLink: string
  more: string
}

export const sampleShareI18n: LocalizedDict<SampleShareStrings> = {
  en: {
    share: 'Share',
    preparing: 'Preparing…',
    message: (label) => `Production sheet — ${label}`,
    mailBody: (label, url) => `Production sheet for ${label}:\n\n${url}`,
    title: 'Share production sheet',
    subtitle: 'Anyone with the link can view the sheet — no login. Expires in 30 days.',
    close: 'Close',
    email: 'Email',
    copied: 'Copied',
    copyLink: 'Copy link',
    more: 'More',
  },
  tr: {
    share: 'Paylaş',
    preparing: 'Hazırlanıyor…',
    message: (label) => `Üretim föyü — ${label}`,
    mailBody: (label, url) => `${label} için üretim föyü:\n\n${url}`,
    title: 'Üretim föyünü paylaş',
    subtitle: 'Bağlantıya sahip olan herkes föyü görebilir — giriş gerekmez. 30 gün sonra geçersiz olur.',
    close: 'Kapat',
    email: 'E-posta',
    copied: 'Kopyalandı',
    copyLink: 'Bağlantıyı kopyala',
    more: 'Diğer',
  },
}
